// extracted by mini-css-extract-plugin
module.exports = {"bold":"OptionDetail-bold-ec82ca93df6db1aceed8b2a80eb03ccf","muted":"OptionDetail-muted-5a27e32d01226227fa606a0a7160accc"};